import request from '@/utils/request'

// 前台获取跟踪列表
export const getTrackLists = (params: any) =>
  request({
    url: '/front/orders/index',
    method: 'post',
    data: params
  })
// 前台下载妥投证明（批量生成可能较慢，单独放宽超时）
export const donwloadDel = (params: any) =>
  request({
    url: '/front/orders/delivered-prove',
    method: 'post',
    data: params,
    timeout: 600000
  })
// 多查询
export const multSearch = (params: any) =>
  request({
    url: '/front/orders/delivered-prove',
    method: 'post',
    data: params
  })
// 导出（批量 1000 单分片查询，单独放宽超时；全局默认仅 25s）
export const orderExport = (params: any) =>
  request({
    url: '/front/orders/export',
    method: 'post',
    data: params,
    timeout: 600000
  })
